import React, { Component, Fragment } from 'react'
import { get, pick } from 'lodash'
import { arrVal, strVal } from '../../../../modules/Utils'
import moment from 'moment/moment'
import { streamUrl } from '../../../../variables/index'
import { Button, Card, Col, Divider, Dropdown, Icon, Menu, message, Popconfirm, Popover, Row, Spin } from 'antd'
import Authentication from '../../../../modules/Authentication'
import Posts from '../../../../api/Posts'
import Comments from '../Comments'
import MemberAvatarView from '../../../../elements/Members/MemberAvatarView'
import Image from './Items/Image'
import Video from './Items/Video'
import PDF from './Items/PDF'
import { PostCard } from '../../../../components/Main/Dashboard/WallTimeLine'

class PostViewCard extends Component {
  constructor(props) {
    super(props)
    const { post, userID } = this.props
    const likes = get(post, 'post.likes') || []
    this.key = get(post, 'post._key') || ''
    this.state = {
      likesNumber: likes.length,
      likes: likes,
      userID,
      deleting: false,
      postDetails: get(post, 'post'),
      fetching: false,
    }
    this.api = new Posts()
  }

  auth = new Authentication()
  handleLike = async () => {
    try {
      this.setState({
        fetching: true,
      })

      const postDetails = await this.api.like(pick(this.state.postDetails, ['_id', '_key', '_rev']))
      this.setState({
        postDetails,
        fetching: false,
      })
    } catch (err) {
      this.setState({
        fetching: false,
      })
      message.error(err.errorMessage)
    }
  }
  delete = async () => {
    this.setState({ deleting: true })
    try {
      await this.api.delete(pick(this.props.post.post, ['_key', '_rev', '_id']))
      this.props.refresh()
      this.setState({ deleting: false })
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({ deleting: false })
    }
  }

  render() {
    const { post } = this.props
    const { postDetails, userID, deleting } = this.state
    let filetype = strVal(postDetails, 'fileList.0.mime')
    const likes = get(postDetails, 'likes') || []
    let fileLinkList = arrVal(postDetails, 'fileList').map(
      (file) =>
        `${streamUrl}files/posts/${strVal(
          file,
          'uuid'
        )}?action=download&type=${filetype}&access_token=${this.auth.getAccessToken()}`
    )

    const heartShape = likes.find((l) => l._id === userID) ? (
      <Icon style={{ color: 'red' }} type="heart" theme="filled" />
    ) : (
      <Icon style={{ color: 'red' }} type="heart" />
    )

    const options = userID === get(post, 'owner._id')

    const fileLink = get(postDetails, 'file')
      ? `${streamUrl}files/posts/${get(
          post,
          'post.file'
        )}?action=download&type=${filetype}&access_token=${this.auth.getAccessToken()}`
      : null

    const oldFileType = strVal(postDetails, 'filetype')

    const ifOldType = !(fileLinkList.length > 0)
    filetype = ifOldType ? oldFileType : filetype
    fileLinkList = ifOldType ? [fileLink] : fileLinkList

    return (
      <PostCard loading={deleting} style={{ width: '100%' }}>
        <Row>
          <Col span={2}>
            <MemberAvatarView id={post.owner.image} />
          </Col>

          <Col span={22}>
            <Row style={{ marginBottom: 10 }}>
              <a style={{ fontSize: '16px', marginLeft: 15 }}>{strVal(post, 'owner.nickname')}</a>
              <span className="ant-divider" />
              <span>{moment(strVal(post, 'post.timestamp')).format('MMM Do YY, hh:mm:ss')}</span>
              {options && (
                <Dropdown
                  placement="bottomCenter"
                  overlay={
                    <Menu>
                      <Menu.Item>
                        <Popconfirm
                          title="Are you sure delete this post?"
                          onConfirm={this.delete}
                          okText="Yes"
                          cancelText="No">
                          <a>Delete</a>
                        </Popconfirm>
                      </Menu.Item>
                    </Menu>
                  }>
                  <Icon
                    style={{
                      fontSize: 22,
                      float: 'right',
                      marginLeft: 8,
                      color: '#08c',
                    }}
                    type="ellipsis"
                  />
                </Dropdown>
              )}
            </Row>
            <Divider />

            <Row>
              <div dangerouslySetInnerHTML={{ __html: strVal(postDetails, 'post') }} style={{ marginTop: 10 }} />
              {filetype.includes('video') && <Video fileLinkList={fileLinkList} />}
                    {filetype.includes('image') && <Image fileLinkList={fileLinkList} />}
              {filetype.includes('application/pdf') && <PDF fileLinkList={fileLinkList} />}
              {post.preview && (
                <Card title={strVal(post, 'preview.title')}>
                  {post.preview.image && (
                    <img style={{ maxHeight: '400px', maxWidth: '400px' }} src={strVal(post, 'preview.image')} />
                  )}
                  {post.preview.siteName && <h3>{strVal(post, 'preview.siteName')}</h3>}
                  {post.preview.url && (
                    <a href={strVal(post, 'preview.url')} target="_blank">
                      {post.preview.url}
                    </a>
                  )}
                  {post.preview.description && <p>{strVal(post, 'preview.description')}</p>}
                </Card>
              )}
            </Row>
          </Col>
        </Row>
        <Row>
          <span>
            {this.state.fetching ? (
              <Spin indicator={<Icon type="loading" style={{ color: 'red' }} spin />} />
            ) : (
              <Fragment>
                <Button
                  onClick={this.handleLike}
                  // type='danger'
                  shape="circle"
                  style={{ marginRight: 12 }}>
                  {heartShape}
                </Button>
                <Popover
                  content={
                    <div>
                      {likes.map((l) => (
                        <p key={l.fn}>{l.fn}</p>
                      ))}
                    </div>
                  }
                  placement="bottom"
                  title="Likes">
                  <a>{likes.length > 0 && likes.length}</a>
                </Popover>
              </Fragment>
            )}
          </span>
          <Comments post={post.post} comments={get(post, 'comment') || []} userID={userID} />
        </Row>
      </PostCard>
    )
  }
}

PostViewCard.propTypes = {}
PostViewCard.defaultProps = {}

export default PostViewCard
